import React from "react";
import AntdBadge from 'antd/lib/badge';
import { withError} from '@fishx/tracker';

const Badge = (props) => <AntdBadge {...props} />
Badge.displayName = 'Badge';
export default withError(Badge);



// WEBPACK FOOTER //
// ./src/components/badge/index.tsx